import { useEffect, useState } from 'react'
import { fetchBankHolidays } from '../utilities/fetchBankHolidays'

const useBankHolidays = (region: string | undefined) => {
  const [bankHolidays, setBankHolidays] = useState<string[]>([])

  useEffect(() => {
    const getBankHols = async () => {
      const bankHols = await fetchBankHolidays(region)
      setBankHolidays(bankHols)
    }
    getBankHols()
  }, [region])

  return bankHolidays
}

export default useBankHolidays
